import { combineReducers } from "redux"
import { serviceEngineer } from './serviceEngineerReducer'

const serviceEngineerReducers = combineReducers({
    serviceEngineer,
})

export default serviceEngineerReducers